<ng-container *ngIf="group" [formGroup]="group">
  <span
    [@slideUpDown]
    *ngIf="error?.message && group.controls[this.control]?.invalid"
    class="form-input-feedback"
    >{{ error?.message }}</span
  >
</ng-container>
